/** Clerk wiring — PencilOut's own Clerk application.
 *
 * The publishable key is public by design (it only identifies the
 * instance; verification happens server-side against the JWKS). The
 * dev-instance key is baked in as the default so local + preview
 * builds are self-contained; production builds override it via
 * ``VITE_CLERK_PUBLISHABLE_KEY`` (a ``pk_live_…``). Setting the env
 * var to an empty string disables Clerk entirely and falls back to
 * the legacy magic-link/OTP login — the escape hatch while the
 * migration is in flight.
 */

import { useClerk } from "@clerk/react";

const raw = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

export const CLERK_PUBLISHABLE_KEY = raw ?? "pk_test_aGFuZHktc2hhZC01OC5jbGVyay5hY2NvdW50cy5kZXYk";

export const CLERK_ENABLED = CLERK_PUBLISHABLE_KEY !== "";

/** ``useClerk()`` that tolerates the provider being absent (Clerk
 * disabled via env). The condition is a build-time constant, so the
 * hook call order never actually changes between renders. */
export function useOptionalClerk() {
  return CLERK_ENABLED ? useClerk() : null;
}
